import axios from "axios";

/**
 * Invite people to a farmer.
 *
 * The endpoint validates a list of rows, so validation errors come back keyed
 * by row: users.0.email, users.1.first_name and so on. Every caller needs that
 * same shape, so the request lives here rather than in each page.
 *
 * @param   {string} farmerHashid
 * @param   {Array}  users  rows of { first_name, last_name, email }
 * @returns {Promise<number>} how many invitations were sent
 * @throws  {Error} with `fieldErrors` set when the server rejected the rows
 */
export async function inviteFarmerUsers(farmerHashid, users) {
    try {
        const response = await axios.post(
            route("app.farmer.invite-users", farmerHashid),
            { users },
            { headers: { Accept: "application/json" } }
        );

        return response.data.invited;
    } catch (error) {
        console.error("Error sending invitations:", error);

        error.fieldErrors = error.response?.data?.errors || null;

        throw error;
    }
}
